
import { ref, computed } from 'vue'

export const useOrientation = () => {
  const orientation = ref(screen.orientation.type)
  const isLandscape = computed(() => orientation.value.includes('landscape'))

  screen.orientation.onchange = () => {
    orientation.value = screen.orientation.type
  }

  return { orientation, isLandscape }
}

export const useTouch = () => {
  const isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0
  return { isTouchDevice }
}

export const useDetectDevice = () => {
  const isMobile = ref(false)
  const isDesktop = ref(false)

  const detectDevice = () => {
    const ua = navigator.userAgent.toLowerCase()

    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    const isCoarsePointer = matchMedia('(pointer: coarse)').matches
    const isSmallScreen = matchMedia('(max-width: 820px)').matches

    const isMobileUA = /android|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua)
    const isTabletUA = /ipad|tablet/i.test(ua)

    const mobile = (isCoarsePointer && isTouch && isSmallScreen) || isMobileUA
    const desktop = !mobile && !isTabletUA

    isMobile.value = mobile
    isDesktop.value = desktop
  }

  detectDevice()

  return { isMobile, isDesktop }
}

export const useApps = () => {
  const getCleanPhone = (phone) => phone.replace(/\s/g, '')

  const openNativeScheme = (url) => {
    window.location.href = url
  }

  const phoneCall = (phoneNumber) => {
    openNativeScheme(`tel:${getCleanPhone(phoneNumber)}`)
  }

  const webUrlOpen = (url) => {
    window.open(url)
  }

  const emailOpen = (email) => {
    openNativeScheme(`mailto:${email}`)
  }

  const whatsappMessage = (phoneNumber) => {
    window.open(`https://wa.me/${getCleanPhone(phoneNumber)}`)
  }

  return {
    getCleanPhone,
    webUrlOpen,
    emailOpen,
    phoneCall,
    whatsappMessage
  }
}

